import React from "react";

const DeleteServices = () => {
  return <div>Delete Services</div>;
};

export { DeleteServices };
